import {
  callApiTaoNhomCongViec,
  callApiSuaNhomCongViec,
  callApiCopyNhomCongViec,
  callApiLayNhomCongViec,
  callApiLayChiTietNhomCongViec,
  callApiXoaNhomCongViec,
  callApiXoaDonViCaNhanTrongNhom,
  callApiThemDonViCaNhan,
  callApiSearchCauHinh,
  callApiUpdateCauHinh,
  callApiGetDanhSachDeMuc,
  callApiSuaDeMuc,
  callApiGetCurrentPhongBan,
  callApiGetListYearFilterLinhVuc,
  callApiGetDanhSachLinhVuc,
  callApiGetChiTietLinhVuc,
  callApiXoaLinhVuc,
  callApiXoaMultiLinhVuc,
  callApiThemLinhVuc,
  callApiSuaLinhVuc,
  callApiListPhongBan,
  callApiGetDanhSachNopLuu,
  callApiGetDonViNhan,
  callApiGetDonViGui,
  callApiAddDonViGui,
  callApiXoaDonViGui,
  callApiGetHasDaiDienBo,
  callApiGetDanhSachCauHinhUyQuyen,
  callApiThayDoiUyQuyen,
  callApiGetNguoiUyQuyen,
  callApiGetDonViUyQuyen,
  callApiGetNguoiDuocUyQuyen,
  callApiGetNguoiTaoHo,
  callApiThemNguoiUyQuyen,
  callApiGetDanhSachViTriUyQuyen,
  callApiSuaNguoiUyQuyen,
  callApiXoaNguoiUyQuyen,
  callApiGetDanhSachQuanLyUyQuyen,
  callApiGetDanhSachDuocUyQuyen,
  callApiGetDanhSachUyQuyen,
  callApiGetQuanLyNguoiUyQuyen,
  callApiThemQuanLyUyQuyen,
  callApiSuaQuanLyUyQuyen,
  callApiXoaQuanLyUyQuyen,
  callApiGetDongBoDanhMucChung,
  callApiDongBoCanBo
} from "@/api/quan-tri-he-thong";

import {
  callSearchMauDuThao,
  callChiTietMauDuThao,
  callApiSuaMauDuThao,
  callApiTaoMauDuThao,
  callApiXoaMauDuThao,
} from "@/api/mau-du-thao";

import Vue from "vue";

const taoNhomCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiTaoNhomCongViec(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaNhomCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaNhomCongViec(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const copyNhomCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiCopyNhomCongViec(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layNhomCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayNhomCongViec(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_DANH_SACH_NHOM_CONG_VIEC", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layChiTietNhomCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayChiTietNhomCongViec(payload)
      .then((response) => {
        if (response) {
          context.commit("SET_CHI_TIET_NHOM_CONG_VIEC", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layChiTietNhomCongViecTrongHT = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayChiTietNhomCongViec(payload)
      .then((response) => {
        if (response) {
          context.commit(
            "SET_CHI_TIET_NHOM_CONG_VIEC_TRONG_HT",
            response.data.Data
          );
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const layChiTietNhomCaNhan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayChiTietNhomCongViec(payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
  });
};

const xoaNhomCongViec = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaNhomCongViec(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaDonViCaNhanTrongNhom = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaDonViCaNhanTrongNhom(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const themDonViCaNhan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemDonViCaNhan(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const searchMauDuThao = (context, payload) => {
  return new Promise((resolve, reject) => {
    callSearchMauDuThao(payload)
      .then((response) => {
        if (response) {
          context.commit("LAY_DANH_SACH_MAU_DU_THAO", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const chiTietMauDuThao = (context, payload) => {
  return new Promise((resolve, reject) => {
    callChiTietMauDuThao(payload)
      .then((response) => {
        if (response) {
          context.commit("CHI_TIET_MAU_DU_THAO", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const searchCauHinh = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSearchCauHinh(payload)
      .then((response) => {
        if (response) {
          context.commit("SEARCH_CAU_HINH", response.data.Data.PageData);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const dongBoDanhMucChung = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDongBoDanhMucChung(payload)
      .then((response) => {
        if (response) {
          context.commit("DONG_BO_DANH_MUC_CHUNG", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const dongBoCanBo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiDongBoCanBo(payload)
      .then((response) => {
        if (response) {
          context.commit("DONG_BO_CAN_BO", response.data.Data);
        }
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaMauDuThao = async (context, payload) => {
  const response = await callApiSuaMauDuThao(payload.data);
  if (response && response.data.IsSuccess) {
    payload.onSuccess && payload.onSuccess(response.data.Data);
    Vue.toasted.global.showSuccessMessage({
      message: "Sửa mẫu dự thảo thành công",
    });
  } else {
    Vue.toasted.global.showErrorMessage({
      message: response.data.Messages[0],
    });
    payload.onFailed && payload.onFailed(response.data.Messages[0]);
  }
};

const taoMauDuThao = async (context, payload) => {
  const response = await callApiTaoMauDuThao(payload.data);
  if (response && response.data.IsSuccess) {
    payload.onSuccess && payload.onSuccess(response.data.Data);
    Vue.toasted.global.showSuccessMessage({
      message: "Tạo mẫu dự thảo thành công",
    });
  } else {
    Vue.toasted.global.showErrorMessage({
      message: response.data.Messages[0],
    });
  }
};

const xoaMauDuThao = async (context, payload) => {
  const response = await callApiXoaMauDuThao(payload.data);
  if (response && response.data.IsSuccess) {
    payload.onSuccess && payload.onSuccess(response.data.Data);
    Vue.toasted.global.showSuccessMessage({
      message: "Xóa mẫu dự thảo thành công",
    });
  } else {
    Vue.toasted.global.showErrorMessage({
      message: response.data.Messages[0],
    });
    payload.onFailed && payload.onFailed(response.data.Messages[0]);
  }
};

const updateCauHinh = async (context, payload) => {
  return  await callApiUpdateCauHinh(payload.data);
};

const getDanhSachDeMuc = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachDeMuc(payload)
      .then((response) => {
        resolve(response.data);
        context.commit("DANH_SACH_DE_MUC", response.data); // Lưu data vào state
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const editDeMuc = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaDeMuc(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const getByCurrentPhongBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetCurrentPhongBan(payload)
      .then((response) => {
        resolve(response.data);
        context.commit("CURRENT_PHONG_BAN_LINH_VUC", response.data);
      })
      .catch((error) => {
        reject(error);
      });
  })
}
const getListYearFilterLinhVuc = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetListYearFilterLinhVuc(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDanhSachLinhVuc = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachLinhVuc(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getChiTietLinhVuc = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetChiTietLinhVuc(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const themLinhVuc = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemLinhVuc(payload)
      .then((response) => {
        if (response) {
          context.commit("THEM_LINH_VUC", response.data);
        }
        resolve(response);
      })
      .catch((error) => {
        context.commit("THEM_LINH_VUC", []);
        reject(error);
      });
  });
};
const editLinhVuc = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaLinhVuc(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const xoaDanhSachLinhVuc = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaLinhVuc(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const xoaMultiLinhVuc = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaMultiLinhVuc(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const getDanhSachPhongBan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiListPhongBan(payload)
      .then((response) => {
        resolve(response.data);
        context.commit("DANH_SACH_PHONG_BAN", response.data); // Lưu data vào state
      })
      .catch((error) => {
        reject(error);
      });
  });
};
const getDanhSachNopLuu = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachNopLuu(payload)
      .then((response) => {
        resolve(response.data);
        context.commit("DANH_SACH_NOP_LUU", response.data); // Lưu data vào state
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDanhSachDonViNhan = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViNhan(payload)
      .then((response) => {
        resolve(response.data);
        context.commit("DANH_SACH_DON_VI_NHAN", response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDanhSachDonViGui = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViGui(payload)
      .then((response) => {
        resolve(response.data);
        context.commit("DANH_SACH_DON_VI_GUI", response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const themDonViGui = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiAddDonViGui(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaDonViGui = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaDonViGui(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getHasDaiDienBo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetHasDaiDienBo(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
// cấu hình ủy quyền
const getDanhSachCauHinhUyQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachCauHinhUyQuyen(payload)
      .then((response) => {
        resolve(response.data);
        context.commit("DANH_SACH_UY_QUYEN", response.data.Data.PageData);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const thayDoiUyQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThayDoiUyQuyen(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getCauHinhNguoiUyQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetNguoiUyQuyen(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getCauHinhDonViUyQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDonViUyQuyen(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getViTriUyQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachViTriUyQuyen(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getCauHinhNguoiDuocUyQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetNguoiDuocUyQuyen(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getCauHinhNguoiTaoHo = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetNguoiTaoHo(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const themNguoiUyQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemNguoiUyQuyen(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaNguoiUyQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaNguoiUyQuyen(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaNguoiUyQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaNguoiUyQuyen(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
// quản lý ủy quyền
const getDanhSachQuanLyUyQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachQuanLyUyQuyen(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDanhSachQuanLyDuocUyQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachDuocUyQuyen(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const getDanhSachUyQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetDanhSachUyQuyen(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};


const getDanhSachQuanLyNguoiUyQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiGetQuanLyNguoiUyQuyen(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const themQuanLyNguoiUyQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiThemQuanLyUyQuyen(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const suaQuanLyNguoiUyQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiSuaQuanLyUyQuyen(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const xoaQuanLyNguoiUyQuyen = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaQuanLyUyQuyen(payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
export default {
  themDonViCaNhan,
  taoNhomCongViec,
  suaNhomCongViec,
  layNhomCongViec,
  layChiTietNhomCongViec,
  xoaNhomCongViec,
  xoaDonViCaNhanTrongNhom,
  searchMauDuThao,
  layChiTietNhomCongViecTrongHT,
  layChiTietNhomCaNhan,
  chiTietMauDuThao,
  suaMauDuThao,
  taoMauDuThao,
  xoaMauDuThao,
  searchCauHinh,
  updateCauHinh,
  getDanhSachDeMuc,
  editDeMuc,
  getByCurrentPhongBan,
  getDanhSachLinhVuc,
  getChiTietLinhVuc,
  getListYearFilterLinhVuc,
  themLinhVuc,
  xoaDanhSachLinhVuc,
  getDanhSachPhongBan,
  editLinhVuc,
  xoaMultiLinhVuc,
  getDanhSachNopLuu,
  getDanhSachDonViNhan,
  getDanhSachDonViGui,
  themDonViGui,
  xoaDonViGui,
  getHasDaiDienBo,
  getDanhSachCauHinhUyQuyen,
  thayDoiUyQuyen,
  getCauHinhNguoiUyQuyen,
  getCauHinhDonViUyQuyen,
  getViTriUyQuyen,
  getCauHinhNguoiDuocUyQuyen,
  getCauHinhNguoiTaoHo,
  themNguoiUyQuyen,
  suaNguoiUyQuyen,
  xoaNguoiUyQuyen,
  getDanhSachQuanLyUyQuyen,
  getDanhSachQuanLyDuocUyQuyen,
  getDanhSachUyQuyen,
  getDanhSachQuanLyNguoiUyQuyen,
  themQuanLyNguoiUyQuyen,
  suaQuanLyNguoiUyQuyen,
  xoaQuanLyNguoiUyQuyen,
  dongBoDanhMucChung,
  dongBoCanBo,
  copyNhomCongViec,
};